import { Outlet } from 'react-router';
import { Toaster } from './components/sonner';

/**
 * Bare top-level layout. It hosts the global toaster and renders the matched
 * route. The authenticated subtree gets its sidebar chrome from the per-area shells
 * (VenueShell, AdminShell); Login and Setup render here with no sidebar.
 */
export function RootLayout() {
  return (
    <>
      <Outlet />
      <Toaster />
    </>
  );
}
